export function isDocumentDarkTheme(): boolean {
  if (typeof document === 'undefined') return false

  const classList = document.documentElement?.classList
  return typeof classList?.contains === 'function' && classList.contains('dark')
}
